/**
 * Staging API Stub for Customer Portal
 *
 * The renderer's TextEditor imports refineText from '../../api/staging'.
 * In the portal context this resolves here. AI refinement is not available
 * for customer-mode editing, so this is a no-op stub.
 */

export type RefinementType = 'shorter' | 'longer' | 'friendlier' | 'professional' | 'regenerate';

export interface RefineTextResponse {
  success: boolean;
  original: string;
  refined: string;
  refinementType: RefinementType;
}

export async function refineText(
  _websiteId: string,
  text: string,
  refinementType: RefinementType,
  _elementLabel?: string,
  _customPrompt?: string
): Promise<RefineTextResponse> {
  // AI refinement is not available in the customer portal
  return {
    success: false,
    original: text,
    refined: text,
    refinementType,
  };
}
